module.exports = __webpack_public_path__ + "img/CIO110_1-1.e55ed959.jpg";